// Paid promotions float to the top of search / category results, but only for the default "Newest first"
// sort (if someone sorts by price or age they asked for a strict order, so we respect it; promoted ads still carry the badge).
// At most MAX are pinned so a few advertisers can never push every normal listing off the first page.
export const MAX_PINNED = 6;

export function boostPromoted(list, sort) {
  if (sort !== "newest" || !Array.isArray(list)) return list;
  const pinned = [], rest = [];
  for (const p of list) (p.promoted && pinned.length < MAX_PINNED ? pinned : rest).push(p);
  return pinned.length ? [...pinned, ...rest] : list;
}

// Counts a click on a promoted ad (best effort, never blocks navigation)
export function trackPromoClick(listingId) {
  if (!listingId) return;
  try {
    fetch("/api/promoted/click", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ listingId }), keepalive: true });
  } catch { /* ignore */ }
}
